import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { patch, del } from "src/utils/networkUtils";

export default function DeactivateAdminDialog({
  open,
  admin,
  onClose,
  onSuccess,
}) {
  const [loading, setLoading] = useState(false);
  const isActive = admin?.is_active;

  const handleConfirm = () => {
    setLoading(true);
    const req = isActive
      ? del(`/admin/users/${admin.id}`)
      : patch(`/admin/users/${admin.id}`, { is_active: true });
    req
      .then(() => {
        onClose();
        onSuccess();
      })
      .finally(() => setLoading(false));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        {isActive ? "Deactivate Admin?" : "Reactivate Admin?"}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          {isActive
            ? `${admin?.email} will lose access immediately.`
            : `${admin?.email} will regain access.`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color={isActive ? "error" : "success"}
          onClick={handleConfirm}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={18} />
          ) : isActive ? (
            "Deactivate"
          ) : (
            "Reactivate"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
